module.exports = __webpack_public_path__ + "img/4.3.TP.80c1bf32.png";